import DataTable from 'components/datatable';
import ErrorBoundary from 'components/ErrorBoundary';
import NotFound404 from 'components/NotFound404';
import Spinner from 'components/Spinner';
import Error from 'components/Error';
import WizardActions from 'components/WizardActions';
import Search from 'containers/search';
import { LESSONS_EDIT } from 'containers/search/SearchType';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Container } from 'rebass';
import { bindActionCreators } from 'redux';
import hasRole from 'util/hasRole';
import {
  clearEditAction,
  updateSearchTermsAction,
} from "../../ducks/lessonsEdit";
import MessageModal from '../../components/modal/MessageModal'
import EditLesson from "./editLesson";
import {I18n} from "react-redux-i18n";


//Can not handle search criteria arrays, just single terms.
const lessonFitsCriteria = (lesson, searchCriteria) => {

  const excludedTerms = ['description', 'examClass'];
  const terms = Object.keys(searchCriteria).filter(term => !excludedTerms.includes(term));

  const fittingTerms = terms.filter(term => searchCriteria[term] === undefined || searchCriteria[term] === "" || searchCriteria[term] === lesson[term]);

  return terms.length === fittingTerms.length;

};

const descriptionFits = (lesson, description) => {

  if (!description || description.length < 3 ) {
    return true;
  }

  return !!lesson.description && lesson.description.toLowerCase().match(new RegExp(description.toLowerCase()));
};

const examClassFits = (lesson, examClass) => {
  return !examClass || lesson.examClasses.map(ec => ec.name).includes(examClass);
}

const filterLessons = (lessons, searchCriteria) => {

  return lessons
    .filter(lesson =>
      descriptionFits(lesson, searchCriteria.description) &&
      examClassFits(lesson, searchCriteria.examClass) &&
      lessonFitsCriteria(lesson, searchCriteria)
    );
};

const getSuccessMessage = (editType) => {
  return editType === 'REMOVE' ? I18n.t('edit_lesson.remove_success'): I18n.t('edit_lesson.save_success')
};

const getFailureMessage = (editType, savingLessonError) => {
  return editType === 'REMOVE' ? I18n.t('edit_lesson.remove_failure')  + savingLessonError.message : I18n.t('edit_lesson.save_failure') + savingLessonError.message
};


class LessonsEdit extends React.Component {

  render() {

    const {
      loggedUser,
      loadingError,
      loading,
      saving,
      lessons,
      searchTerms,
      updateSearchTerms,
      lessonEdited,
      examClasses,
      error,
      loadingLesson,
      clearEdit,
      newLesson,
      lessonSavedInfo,
      savingLessonError,
      lessonSaveShown,
      editType,
    } = this.props;

    const isAllowed = hasRole(loggedUser, ['KULTU_SEURANTA_ADMIN']);

    if (isAllowed) {
      return (
        <Container
          textAlign='center'
          pb={7}>
          <ErrorBoundary>
            {saving && <Spinner />}

            {!lessonEdited &&
            <Container>
              <Search
                searchType={LESSONS_EDIT}
                updateSearchTerms={updateSearchTerms}
                searchTerms={searchTerms}
              />

              {loading && !loadingError && <Spinner />}
              {loadingError && <Error message={loadingError.message} />}

              {error && <Error message={error.message} />}
              {!!lessons && lessons.length > 0  && !loading && !error &&
              <DataTable
                tableType={"LESSONS_EDIT"}
                rows={filterLessons(lessons, searchTerms)}
                rowKey='entityId'
                tableHeight='60vh'
              />
              }
              {false && <WizardActions nextText='action.new_lesson' nextFn={() => newLesson()} />}
            </Container>
            }

            {!!lessonEdited &&
            <Container>
              <EditLesson lesson={lessonEdited}
                          examClasses={examClasses}
                          loadingLesson={loadingLesson}
                          clearEdit={()=> {clearEdit()}}
              />
            </Container>
            }

            { !!lessonSavedInfo && !savingLessonError && <MessageModal messageType='SUCCESS' message={getSuccessMessage(editType)} hideModal={()=>lessonSaveShown()}/>}
            { !!lessonSavedInfo && !!savingLessonError && <MessageModal messageType='ERROR' message={getFailureMessage(editType, savingLessonError)} hideModal={()=>lessonSaveShown()}/>}
          </ErrorBoundary>
        </Container>
      );
    } else {
      return <NotFound404 message={!isAllowed && 'app.missing_perm'} />;
    }
  }
}

LessonsEdit.propTypes = {
  loggedUser: PropTypes.object,
  saving: PropTypes.bool,
  loading: PropTypes.bool,
  error: PropTypes.object,
  loadingError: PropTypes.object,
  lessons: PropTypes.array,
  searchTerms: PropTypes.object,
  lessonEdited: PropTypes.object,
  examClasses: PropTypes.array,
  loadingLesson: PropTypes.bool,
  lessonSavedInfo: PropTypes.bool,
  savingLessonError: PropTypes.object,
  editType: PropTypes.string,

};

const mapStateToProps = (state) => {
  return {
    loggedUser: state.userState.user,
    saving: state.applicantLessonStatus.loading.saving,
    loading: state.general.loading,
    loadingError: state.general.error,
    lessons: state.general.lessons,
    searchTerms: state.lessonsEdit.searchTerms,
    lessonEdited: state.lessonsEdit.lessonEdited,
    error: state.lessonsEdit.error,
    examClasses: state.general.examClasses,
    loadingLesson:state.lessonsEdit.loadingLesson,
    lessonSavedInfo: state.lessonsEdit.lessonSavedInfo,
    savingLessonError: state.lessonsEdit.savingLessonError,
    editType: state.lessonsEdit.editType
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({
  updateSearchTerms: (searchTerms) => updateSearchTermsAction(searchTerms),
  clearEdit: () => clearEditAction(),
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LessonsEdit);


// WEBPACK FOOTER //
// ./src/containers/lessonsEdit/index.js